<boi-main-layout class="mortgage-application" [hasStickHeader]="true"  [scrollStickyHeaderHeight]="180">
    <div boiStickyHeader secondaryHeader>
        <boi-case-summary-header [model]="kfi.ApplicationCase" [displayAdviceTabLink]="true"
            [headerTextName]="referenceDataLabels.KeyFactsIllustrationKfiId">
        </boi-case-summary-header>

        <div class="menu sticky-content">
            <nav class="app-tabs">

                <boi-form-application-tab [label]="referenceDataLabels.SectionTitleMortgage|localizeLabel"
                    [routerLink]="['/', 'kfi', kfiId, 'kfiYourMortgage']"
                    [hasSubmitValidationError]="hasSubmitValidationError" [progress]="sections?.YourMortgage?.Progress"
                    [cssClass]="'mortgage'">
                </boi-form-application-tab>

                <boi-form-application-tab [label]="referenceDataLabels.ApplicantsId|localizeLabel"
                    [routerLink]="['/', 'kfi', kfiId, 'kfiApplicants']"
                    [hasSubmitValidationError]="hasSubmitValidationError" [progress]="sections?.Applicants?.Progress"
                    [cssClass]="'applicant'">
                </boi-form-application-tab>
            </nav>
        </div>
    </div>

    <div leftPageContent>
        <router-outlet></router-outlet>
    </div>

    <div rightPageContent>
        <boi-kfi-progress-stepper [sections]="sections" [activeTab]="activeTab"
            [hasSubmitValidationError]="hasSubmitValidationError"></boi-kfi-progress-stepper>
        <button [boiPermissionChecker]="[userPermissions.CreateKfi]" (click)="submit()"
            class="submit-app-button">{{referenceDataLabels.GenerateKfi|localizeLabel}}</button>
        <boi-contextual-help-displayer></boi-contextual-help-displayer>
    </div>
</boi-main-layout>
